export const STAKINGLOCKSTATUS = [
    {value: "", label: "全部"},
    {value: 2, label: "等待锁仓"},
    {value: 3, label: "锁仓中"},
    {value: 4, label: "完成"},
    {value: -1, label: "已取消"}
]

export const STAKINGUNLOCKSTATUS = [
    {value: "", label: "全部"},
    {value: 2, label: "等待确认"},
    {value: 3, label: "等待解锁"},
    {value: 4, label: "解锁中"},
    {value: 5, label: "完成"},
    {value: -1, label: "已取消"}
]

